import { useEffect, useState } from "react";

export default function DokToc({ overskrifter, editor }) {
  const [aktiv, setAktiv] = useState(0);

  useEffect(() => {
    if (!overskrifter.length || !editor) return undefined;
    let raf = 0;
    const kalk = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        let idx = 0;
        overskrifter.forEach((h, i) => {
          try {
            const dom = editor.view.domAtPos(h.pos + 1);
            const el = dom.node.nodeType === 1 ? dom.node : dom.node.parentElement;
            if (el && el.getBoundingClientRect().top <= 170) idx = i;
          } catch { /* posisjon kan ha flyttet seg */ }
        });
        setAktiv(idx);
      });
    };
    window.addEventListener("scroll", kalk, { passive: true });
    kalk();
    return () => { window.removeEventListener("scroll", kalk); cancelAnimationFrame(raf); };
  }, [overskrifter, editor]);

  if (!overskrifter.length) return null;
  const hopp = (pos) => {
    try {
      const dom = editor.view.domAtPos(pos + 1);
      const el = dom.node.nodeType === 1 ? dom.node : dom.node.parentElement;
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    } catch { /* posisjon kan ha flyttet seg */ }
  };
  return (
    <nav className="dok-toc" data-testid="dok-toc">
      <p className="text-[9.5px] font-semibold uppercase tracking-[0.18em] text-neutral-400 mb-2.5">På denne siden</p>
      <div className="space-y-0.5">
        {overskrifter.map((h, i) => (
          <button
            key={`${h.pos}-${i}`}
            type="button"
            onClick={() => hopp(h.pos)}
            className={`dok-toc-rad block w-full text-left text-[11.5px] leading-snug truncate py-[3px] ${i === aktiv ? "aktiv" : ""}`}
            style={{ paddingLeft: (h.level - 1) * 12 }}
            data-testid={`dok-toc-${i}`}
          >
            {h.tekst || "…"}
          </button>
        ))}
      </div>
    </nav>
  );
}
